<template>
  <div id="22_main">
    <v-row>
      <v-alert v-show="errorAlertShow" dense outlined type="error"><strong>Критична помилка! </strong>( {{errorMessage}} )</v-alert>
      <v-progress-linear v-show="progresLineShow" indeterminate fixed color="red"></v-progress-linear>
    </v-row>

    <div
      class="d-flex justify-space-around flex-wrap"

    >

      <v-card
        v-for="verstat in verstatsList"
        :key="verstat.id"
        class="mt-2"
        max-width="344"
        color="#4DB6AC"
       
      >
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="headline">{{ verstat.nameverstat }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-img
          src="img/verstats/kugler.jpg"
          height="200px"
        >
        </v-img>
        <v-card-text>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon >
            <v-icon>mdi-account-details</v-icon>
          </v-btn>
        </v-card-actions>
      
      </v-card>

    </div>

  </div>
</template>

<script>
  export default {
    data: function () {
      return {
        errorMessage: '',
        errorAlertShow: false,
        progresLineShow: false,
        verstatsList: [],
        
      }
    },
    watch: {
      
    },
    methods: {
      getVerstatList () {
        this.progresLineShow = true;
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            act: '22',
            ww: '1',
            pp: localStorage.pp,
            pn: localStorage.pn,
          })
        };
        fetch(this.$store.getters.apiUrl, requestOptions)
        .then(async response => {
          const data = await response.json();
          if (!response.ok) {
            const error = (data && data.message) || response.status;
            return Promise.reject(error);
          }
          if (data.isauth == true) {
            this.verstatsList = data.verstatsList;
            this.progresLineShow = false;
          }
          if (data.isauth == false) {
            this.$router.push('/login').catch(()=>{})
          }
        })
        .catch(error => {
          this.errorMessage = error;
          this.progresLineShow = false;
          this.errorAlertShow = true;
          console.error('Error!', error);
        });
      },

    },
    computed: {
      
    },
    created: function () {
      this.getVerstatList()
    },
  }
</script>